<template>
  <div class="row">
    <div v-if="Errors.length" class="alert alert-danger">
      <b>Please correct the following error(s):</b>
      <ul style="list-style: none">
        <li v-for="error in Errors" :key="'error-' + error">
          {{ error }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "AddSubscriberErrors",
  computed: {
    Errors() {
      return this.$store.state.testdrive.addSubscriberErrors;
    },
  },
};
</script>
